angular.module('inspecciones')
    .controller('inspeccionPresaController', ['$rootScope', '$scope', '$location', '$route', '$routeParams', 'inspeccionesService', 'TVService', 'infraestructurasService', 'infraestructurasAdminService', 'authenticationInfo', 'authenticationService', '$sce',
        function ($rootScope, $scope, $location, $route, $routeParams, inspeccionesService, TVService, infraestructurasService, infraestructurasAdminService, authenticationInfo, authenticationService, $sce) {

            $scope.mostrar = function (loader) {
                var elemento = document.getElementById(loader);
                elemento.style.display = 'block';
            }

            $scope.refrescarDanos = function () {

                $scope.mostrar('loader-seguimiento');
                inspeccionesService.getDaños($routeParams.id)
                    .then(function (response) {
                        $scope.damages = response.data;
                        $scope.ocultar('loader-seguimiento');
                    });
            }

            $scope.damageBarChartSeccion = null;

            $scope.authentication = authenticationInfo;
            //$scope.InfraestructuraId = $routeParams.idInfraestructura;

            $scope.InspeccionId = $routeParams.id;

            if ($rootScope.damageUrl === true) {
                $scope.pestanyamenuinspeccion = 'danosgenerales';
                $rootScope.damageUrl = false;
                $scope.refrescarDanos(); // ✅ ahora sí es seguro llamar
            }
            else {
                $scope.pestanyamenuinspeccion = 'general';
            }

            inspeccionesService.getPresaId($rootScope.InfraestructuraId)
                .then(function (response) {
                    $scope.PresaId = response.data;
                });


            infraestructurasAdminService.getPropietarios()
                .then(function (response) {
                    var data = response.data;
                    $scope.propietarios = data;
                });

            infraestructurasAdminService.getInspectores()
                .then(function (response) {
                    var data = response.data;
                    $scope.inspectores = data;
                });

            $scope.danosAgrupados = [];
            $scope.danos = [];
            $scope.elementos = [];

            $scope.selectedTipologiaId = null;
            $scope.selectedDano = null;

            inspeccionesService.getTipologiasPresa()
                .then(function (response) {
                    var data = response.data;
                    $scope.tipologias = data;
                });

            inspeccionesService.getTiposDañoPresa()
                .then(function (response) {
                    var data = response.data;
                    $scope.danosAgrupados = data;
                });

            inspeccionesService.getElementosPresa()
                .then(function (response) {
                    var data = response.data;
                    $scope.elementosAgrupados = data;
                });

            inspeccionesService.getIntensidadesPresa()
                .then(function (response) {
                    var data = response.data;
                    $scope.intensidadesAgrupadas = data;
                });

            inspeccionesService.getdamagesporInspeccion($scope.InspeccionId)
                .then(function (response) {
                    var data = response.data;
                    $scope.danosPresa = data;
                });



            $scope.onTipologiaChange = function (tipologiaId) {
                $scope.selectedDano = null;
                $scope.selectedElemento = null;
                $scope.selectedIntensidad = null;
                $scope.danos = [];
                $scope.elementos = [];
                $scope.intensidades = [];

                if (!tipologiaId) return;

                var grupo = $scope.danosAgrupados.find(function (g) {
                    return g.TipologiaId === tipologiaId;
                });

                $scope.danos = grupo ? grupo.Danos : [];
            };

            $scope.onDanoChange = function (dano) {
                $scope.selectedElemento = null;
                $scope.elementos = [];
                $scope.selectedIntensidad = null;
                $scope.intensidades = [];

                if (!dano) return;

                for (var i = 0; i < $scope.elementosAgrupados.length; i++) {
                    if ($scope.elementosAgrupados[i].CodigoDano === dano.CodDano) {
                        $scope.elementos = $scope.elementosAgrupados[i].Elementos;
                        break;
                    }
                }

                for (var i = 0; i < $scope.elementosAgrupados.length; i++) {
                    if ($scope.intensidadesAgrupadas[i].CodigoDano === dano.CodDano) {
                        $scope.intensidades = $scope.intensidadesAgrupadas[i].Intensidades;
                        break;
                    }
                }

            };




            $scope.indice = 0;

            if ($scope.InspeccionId > 0) {
                inspeccionesService.getInspeccionPresa($scope.InspeccionId)
                    .then(function (response) {
                        var data = response.data;
                        $scope.inspeccion = data;
                        $scope.inspeccion.Descripcion = $scope.inspeccion.Descripcion.toString();
                        $scope.inspeccion.FechaInicio = $scope.inspeccion.FechaInicio.toString();
                        $scope.inspeccion.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin.toString() : ''; // Verificación específica
                        $scope.inspeccion.FechaInspAnterior = dateFormat($scope.inspeccion.FechaInspAnterior ? $scope.inspeccion.FechaInspAnterior.toString() : '', "dd/mm/yyyy");
                        //$scope.inspeccion.FechaInspAnterior = dateFormat($scope.inspeccion.FechaInspAnterior, "dd/mm/yyyy");
                        $scope.inspeccion.Inspector = $scope.inspeccion.Inspector.toString();
                        $scope.inspeccion.Propietario = $scope.inspeccion.Propietario.toString();
                        $scope.inspeccion.InspectorId = $scope.inspeccion.InspectorId.toString();
                        $scope.inspeccion.PropietarioId = $scope.inspeccion.PropietarioId.toString();

                        $scope.inspeccion.Comentarios = $scope.inspeccion.Comentarios.toString();
                        
                    })
            }


            TVService.getSitioInspeccion($scope.InspeccionId)
                .then(function (response) {
                    var data = response.data;
                    $scope.sitio = data;
                    //   $scope.sitioUrl = $sce.trustAsHtml("<iframe src='https://nube.infraestructuradigital.es/views/EntornoPruebasv2.html' style='width: 100%; height: 800px'></iframe>");
                    $scope.sitioUrl = $sce.trustAsHtml($scope.sitio);
                });



            $scope.verDamage = function (idDaño) {
                $location.url('/damages/' + $scope.InspeccionId + '/' + idDaño);
            }

            $scope.validarSeleccion = function () {
                if (!$scope.informeSeleccionado) {
                    // Si no se selecciona un informe, muestra una alerta
                    alert("Por favor, seleccione un informe antes de continuar.");
                    return;
                }

                // Si se seleccionó un informe, procede con la generación
                $scope.imprimirInforme();

                //$scope.imprimirListadoDaños();

            };


            $scope.imprimirInforme = function () {
                if ($scope.informeSeleccionado == "Listado Daños") {
                    infraestructurasService.getListado($scope.InspeccionId)
                        .then(function (data, status, headers) {

                            var filename = "Listado de Daños por Inspeccion.doc";
                            var contentType = 'application/msword';

                            var blob = new Blob([data.data],
                                { type: contentType });

                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                window.navigator.msSaveBlob(blob, filename);
                            else //Resto
                            {
                                var downloadLink = document.createElement("a");
                                var url = window.URL.createObjectURL(blob);
                                downloadLink.setAttribute("target", "_blank");
                                downloadLink.setAttribute("href", url);
                                downloadLink.setAttribute("download", filename);
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                                elemento.style.display = 'none';
                            }
                        })
                }
                else {
                    infraestructurasService.getInforme($scope.InspeccionId)
                        .then(function (data, status, headers) {

                            var filename = "Informe inspeccion.doc";
                            var contentType = 'application/msword';

                            var blob = new Blob([data.data],
                                { type: contentType });

                            if (navigator.appVersion.toString().indexOf('.NET') > 0) //IE
                                window.navigator.msSaveBlob(blob, filename);
                            else //Resto
                            {
                                var downloadLink = document.createElement("a");
                                var url = window.URL.createObjectURL(blob);
                                downloadLink.setAttribute("target", "_blank");
                                downloadLink.setAttribute("href", url);
                                downloadLink.setAttribute("download", filename);
                                document.body.appendChild(downloadLink);
                                downloadLink.click();
                                document.body.removeChild(downloadLink);
                                elemento.style.display = 'none';
                            }
                        })
                    //    })
                }
            }


            $scope.volver = function () {
                $location.path('/infraestructura/' + $rootScope.InfraestructuraId);
                $rootScope.inspeccionUrl = true;
            }


            $scope.tablaprecios = function() {
                $location.path('/admin/preciosAdmin');
            }


            $scope.guardar = function (mostrarAlerta) {
                const timeElapsed = Date.now();
                const today = new Date(timeElapsed);

                var inspeccionSQL = new Object();
                inspeccionSQL.Id = $scope.InspeccionId;
                inspeccionSQL.Descripcion = $scope.inspeccion.Descripcion;
                inspeccionSQL.FechaInicio = $scope.inspeccion.FechaInicio;
                inspeccionSQL.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin : ''; // Verificación específica
                inspeccionSQL.InspectorId = $scope.inspeccion.InspectorId;
                inspeccionSQL.PropietarioId = $scope.inspeccion.PropietarioId;
                inspeccionSQL.Comentarios = $scope.inspeccion.Comentarios;

                inspeccionSQL.PresaId = $scope.PresaId;


                    if (!$scope.inspeccion.FechaInicio) {
                        alert("Debe introducir la Fecha de Inicio de la inspección.");
                        return; // Salir si las fechas no son válidas
                    }
                    $scope.mostrar('loader-seguimiento');


                    inspeccionesService.putInspeccionPresa(inspeccionSQL)
                        .then(function (data) {

                            if ($scope.InspeccionId == 0) {
                                //$scope.InspeccionId = data.data;
                                $scope.ocultar('loader-seguimiento');
                                alert('Datos guardados correctamente');
                                $location.url('/inspecciones/' + data.data)
                            }
                            else {
                                $scope.InspeccionId = $scope.InspeccionId;
                            }

                            $routeParams.id = $scope.InspeccionId;
                            inspeccionesService.getInspeccionPresa($scope.InspeccionId)
                                .then(function (response) {
                                    var data = response.data;
                                    $scope.inspeccion = data;
                                    $scope.inspeccion.Descripcion = $scope.inspeccion.Descripcion.toString();
                                    $scope.inspeccion.FechaInicio = $scope.inspeccion.FechaInicio.toString();
                                    $scope.inspeccion.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin.toString() : ''; // Verificación específica
                                    $scope.inspeccion.Inspector = $scope.inspeccion.Inspector.toString();
                                    $scope.inspeccion.Propietario = $scope.inspeccion.Propietario.toString();
                                    $scope.inspeccion.PresaId = $scope.PresaId.toString();
                                    $scope.inspeccion.InspectorId = $scope.inspeccion.InspectorId.toString();
                                    $scope.inspeccion.PropietarioId = $scope.inspeccion.PropietarioId.toString();
                                    $scope.inspeccion.Comentarios = $scope.inspeccion.Comentarios.toString();
                                    $scope.ocultar('loader-seguimiento');
                                    alert('Datos guardados correctamente');
                                })
                        })

            };

            $scope.logout = function () {
                return authenticationService.logout();
            }


            $scope.refrescarGeneral = function () {
                $scope.pestanyavisible = 'general';
                $scope.pestanyamenuinspeccion = 'general';
                inspeccionesService.getInspeccionPresa($routeParams.id)
                    .then(function (response) {
                        var data = response.data;
                        $scope.inspeccion = data;
                        $scope.inspeccion.Descripcion = $scope.inspeccion.Descripcion.toString();
                        $scope.inspeccion.FechaInicio = $scope.inspeccion.FechaInicio.toString();
                        $scope.inspeccion.FechaFin = $scope.inspeccion.FechaFin ? $scope.inspeccion.FechaFin.toString() : ''; // Verificación específica
                        $scope.inspeccion.FechaInspAnterior = dateFormat($scope.inspeccion.FechaInspAnterior ? $scope.inspeccion.FechaInspAnterior.toString() : '', "dd/mm/yyyy");
                        $scope.inspeccion.Inspector = $scope.inspeccion.Inspector.toString();
                        $scope.inspeccion.Propietario = $scope.inspeccion.Propietario.toString();
                        $scope.inspeccion.InspectorId = $scope.inspeccion.InspectorId.toString();
                        $scope.inspeccion.PropietarioId = $scope.inspeccion.PropietarioId.toString();
                        $scope.inspeccion.Comentarios = $scope.inspeccion.Comentarios.toString();


                    })
            }

            


            //if ($rootScope.damageUrl == true) {
            //    $scope.InspeccionId = $routeParams.id;
            //    $scope.pestanyamenuinspeccion = 'danosgenerales';
            //    $rootScope.damageUrl = false;
            //    $scope.refrescarDanos();
            //}
            //else {

            //}

            $scope.refrescarInspeccionar = function () {
                $scope.pestanyamenuinspeccion = 'inspeccionar';
            }


            $scope.refrescarPorPk = function () {
                $scope.pestanyamenuinspeccion = 'dañosporpk';
                inspeccionesService.getDañosPorPK($routeParams.id, $scope.seccion)
                    .then(function (response) {
                        $scope.damagesporpk = response.data;
                    });
            }

            $scope.refrescarPorTipo = function () {
                $scope.pestanyamenuinspeccion = 'dañosportipo';
                inspeccionesService.getDañosPorTipo($routeParams.id)
                    .then(function (response) {
                        $scope.damagesportipo = response.data;
                    });
            }


            $scope.refrescarReparaciones = function () {
                $scope.pestanyamenuinspeccion = 'reparaciones';
                inspeccionesService.getReparaciones($routeParams.id)
                    .then(function (response) {
                        $scope.damagesporreparacion = response.data;
                    });
            }


            $scope.refrescarPorElemento = function () {
                $scope.pestanyamenuinspeccion = 'dañosporelemento';
                inspeccionesService.getDañosPorElemento($routeParams.id)
                    .then(function (response) {
                        $scope.damagesporelemento = response.data;
                    });
            }

            $scope.refrescarPorSeccion = function () {
                $scope.pestanyamenuinspeccion = 'dañosporseccion';
                $scope.mostrar('loader-seguimiento-seccion');
                inspeccionesService.getDañosPorSeccion($routeParams.id, $scope.seccion)
                    .then(function (response) {
                        $scope.dañosSeccion = response.data;

                        // Generar dinámicamente los labels y los datos basados en $scope.daños
                        const labelsSec = $scope.dañosSeccion.map(function (d) {
                            return d.Seccion || 0;
                        });

                        const dataLeveSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[0].Conteo || null;
                        });

                        const dataModSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[1].Conteo || null;
                        });

                        const dataSevSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[2].Conteo || null;
                        });

                        const dataCritSec = $scope.dañosSeccion.map(function (d) {
                            return d.Gravedades[3].Conteo || null;
                        });



                        //const labelsSeccion = { count: 7 };
                        const dataSec = {
                            labels: labelsSec,
                            datasets: [
                                {
                                    label: 'Leve',
                                    data: dataLeveSec,
                                    backgroundColor: 'rgba(0, 128, 0, 0.7)',
                                },
                                {
                                    label: 'Moderado',
                                    data: dataModSec,
                                    backgroundColor: 'rgba(255, 255, 0, 0.7)',
                                },
                                {
                                    label: 'Severo',
                                    data: dataSevSec,
                                    backgroundColor: 'rgba(255, 165, 0, 0.7)',
                                },
                                {
                                    label: 'Critico',
                                    data: dataCritSec,
                                    backgroundColor: 'rgba(255, 0, 0, 0.7)',
                                },
                            ]
                        };

                        const configSec = {
                            type: 'bar',
                            data: dataSec,
                            options: {
                                plugins: {
                                    title: {
                                        display: true,
                                        text: 'Distribución de Daños por Sección',
                                        font: {
                                            size: 16
                                        }
                                    },
                                    tooltip: {
                                        mode: 'index', // Muestra todos los valores en la misma posición de X
                                        intersect: false, // Tooltip se activa en toda la barra
                                        callbacks: {
                                            title: function () {
                                                return ''; // Oculta el valor del eje X en el tooltip
                                            },
                                            label: function (tooltipItem) {
                                                // Si el valor es null o 0, no mostrarlo
                                                if (tooltipItem.raw === null || tooltipItem.raw === 0) {
                                                    return null; // No devuelve nada (se oculta en el tooltip)
                                                }
                                                return tooltipItem.dataset.label + ': ' + tooltipItem.raw;
                                            }
                                        }
                                    }
                                },
                                interaction: {
                                    mode: 'index',
                                    intersect: false
                                },
                                responsive: true,
                                scales: {
                                    x: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Sección (metros)', // Etiqueta del eje X
                                            font: {
                                                size: 14
                                            }
                                        },
                                        ticks: {
                                            align: 'start' // Alinea las etiquetas al inicio de cada sección
                                        },
                                        grid: {
                                            drawBorder: true,
                                            drawOnChartArea: false, // Dibuja la línea en el eje X
                                            drawTicks: true
                                        }
                                    },
                                    y: {
                                        stacked: true,
                                        title: {
                                            display: true,
                                            text: 'Cantidad de Daños', // Etiqueta del eje Y
                                            font: {
                                                size: 14
                                            }
                                        }
                                    }
                                },
                            }
                        };
                        if ($scope.damageBarChartSeccion) {
                            $scope.damageBarChartSeccion.destroy();
                        }

                        const ctxSec = document.getElementById('graficoDaniosPorSeccion').getContext('2d');
                        $scope.damageBarChartSeccion = new Chart(ctxSec, configSec);
                        $scope.ocultar('loader-seguimiento-seccion');
                    });
            }

            $scope.guardarDanoPresa = function () {
                inspeccionesService.guardarDañoPresa($scope.selectedTipologiaId, $scope.selectedDano.IdDano, $scope.selectedElemento.IdElemento, $scope.selectedIntensidad.IdIntensidad, $scope.InspeccionId)
                    .then(function (response) {
                        $scope.danosPresa = response.data;
                        inspeccionesService.actualizarEscenario($scope.InspeccionId)
                            .then(function (response) {
                            });
                    });
            }

            $scope.eliminarDanoPresa = function (idDano) {
                check = confirm("¿Seguro que deseas eliminar este daño?")

                if (check) {
                    inspeccionesService.eliminarDañoPresa(idDano)
                        .then(function (response) {
                            $scope.danosPresa = response.data;
                            inspeccionesService.actualizarEscenario($scope.InspeccionId)
                                .then(function (response) {
                                });
                        });
                }
            }


            $scope.verCategorias = function () {
                $rootScope.inspeccionUrl = false;
                $rootScope.parteUrl = false;
                $location.path('/categorias');
            };

            $scope.ocultar = function (loader) {
                var elemento = document.getElementById(loader);
                elemento.style.display = 'none';
            }

            
        }
    ]);